import _ from 'lodash';
import axios from 'axios';
import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import { useHistory } from 'react-router';
import Loader from 'react-loader-spinner';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState, useCallback } from 'react';

import { classes } from '../styles';
import MuiTable from '../../../components/Dashboard/Common/Table';
import DashboardNavBar from '../../../components/Dashboard/Common/Navbar';
import DashboardSideMenu from '../../../components/Dashboard/Common/SidebarMenu';

const columns = [
  { id: 'no', label: 'No', minWidth: 50, align: 'left' },
  { id: 'sponsoredKid', label: 'Sponsored Kid', minWidth: 250, align: 'left' },
  {
    id: 'amount',
    label: 'Amount ($)',
    minWidth: 150,
    align: 'left',
  },
  {
    id: 'paid',
    label: 'Paid',
    minWidth: 100,
    align: 'left',
  },
  {
    id: 'firstName',
    label: 'Donator First Name',
    minWidth: 200,
    align: 'left',
  },
  { id: 'lastName', label: 'Donator Last Name', minWidth: 200, align: 'left' },
  {
    id: 'email',
    label: 'Donator Email',
    minWidth: 250,
    align: 'left',
  },
  {
    id: 'address',
    label: 'Donator Address',
    minWidth: 200,
    align: 'left',
  },
  { id: 'active', label: 'Active', minWidth: 100, align: 'left' },
  {
    id: 'message',
    label: 'Donator Message',
    minWidth: 300,
    align: 'left',
  },
  {
    id: 'stripeChargeId',
    label: 'Stripe Charge Id',
    minWidth: 200,
    align: 'left',
  },
  {
    id: 'stripeReceiptUrl',
    label: 'Stripe Receipt URL',
    minWidth: 300,
    align: 'left',
  },
  {
    id: 'registered',
    label: 'Registered',
    minWidth: 150,
    align: 'left',
  },
];

const baseUrl = process.env.REACT_APP_BASE_URL;
const token = localStorage.getItem('lhcfToken');

const DashboardSponsoredKidsDonationsPage = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [donations, setDonations] = useState([]);
  const [loadingError, setLoadingError] = useState(false);

  const handleRowClick = ({ donationId }) => {
    history.push(`/dashboard/donations-sponsored-kids/${donationId}`);
  };

  const createData = (
    no,
    sponsoredKid,
    amount,
    paid,
    firstName,
    lastName,
    email,
    address,
    active,
    message,
    stripeChargeId,
    stripeReceiptUrl,
    registered,
    donationId
  ) => ({
    no,
    sponsoredKid,
    amount,
    paid,
    firstName,
    lastName,
    email,
    address,
    active,
    message,
    stripeChargeId,
    stripeReceiptUrl,
    registered,
    donationId,
  });

  const prepareTableRows = useCallback((newDonations) => {
    const rows = [];

    newDonations.forEach((donation, index) => {
      rows.push(
        createData(
          index + 1,
          donation.sponsoredKid
            ? donation.sponsoredKid.firstName +
                ' ' +
                donation.sponsoredKid.lastName
            : 'the sponsored kid no longer exists in the system. they may have been deleted.',
          donation.amount,
          donation.paid ? 'Yes' : 'No',
          donation.firstName,
          donation.lastName,
          donation.email,
          donation.address,
          donation.active ? 'Yes' : 'No',
          donation.message,
          donation.stripeChargeId,
          donation.stripeReceiptUrl,
          donation.createdAt.split('T')[0],
          donation._id
        )
      );
    });

    return rows;
  }, []);

  const fetchDonations = useCallback(
    (page, limit) => {
      axios
        .get(`${baseUrl}/sponsored-kid-donation?page=${page}&limit=${limit}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then(
          ({
            data: {
              data: { docs = [] },
            },
          }) => {
            if (docs.length) {
              const donations = prepareTableRows(docs);

              setDonations((prevState) => {
                const prevDonations = [...prevState];
                const newDonations = [...donations];

                return _.unionWith(prevDonations, newDonations, _.isEqual);
              });
            } else {
              setDonations([]);
            }

            setLoading(false);
          }
        )
        .catch((err) => {
          setLoadingError(true);
          setLoading(false);
        });
    },
    [prepareTableRows]
  );

  useEffect(() => {
    fetchDonations(1, 500);
  }, [fetchDonations]);

  return (
    <Box sx={classes.container}>
      <DashboardNavBar />
      <DashboardSideMenu />
      {/* PAGE */}
      <Box sx={classes.pageContainer}>
        {loading ? (
          <Box sx={classes.commonMargin}>
            <Loader type="Oval" color="#B40404" height={80} width={80} />
          </Box>
        ) : loadingError ? (
          <Box sx={classes.commonMargin}>
            <Typography variant="subtitle1" component="div">
              Could not fetch sponsored kids donations. Refresh or check back
              later.
            </Typography>
          </Box>
        ) : (
          <>
            {donations.length ? (
              <MuiTable
                columns={columns}
                rows={donations}
                handleRowClick={handleRowClick}
              />
            ) : (
              <Typography variant="button" component="div" sx={classes.noData}>
                There are no sponsored kids donations at the moment. Click on
                the button below to register a paid donation.
              </Typography>
            )}

            <Fab
              color="primary"
              aria-label="add"
              sx={classes.floatingButton}
              onClick={() =>
                history.push('/dashboard/donations-sponsored-kids/new')
              }
            >
              <AddIcon />
            </Fab>
          </>
        )}
      </Box>
    </Box>
  );
};

export default DashboardSponsoredKidsDonationsPage;
